export enum SortingLabels {
  popular = 'categoriesFilterPopular',
  ascPrice = 'highPriceFilter',
  descPrice = 'lowPriceFilter',
  descDiscount = 'lowDiscountPercentSorting',
}
